export * from './MatchingProducts';

import { MatchingProducts } from './MatchingProducts';

export default MatchingProducts;
